import { createSlice } from '@reduxjs/toolkit';
import { getLegacyComunas } from '../legacy/thunk.js';

export const initialState = {
    legacyComunas: [],
    loading: false,
    error: {},
};

const legacyComunasSlice = createSlice({
    name: 'legacyComunas',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyComunas.fulfilled, (state, action) => {
            state.legacyComunas = action.payload;
            state.loading = true;
        });
        builder.addCase(getLegacyComunas.rejected, (state, action) => {
            state.error = action.payload.error || null;
            state.loading = true;
        });
        builder.addCase(getLegacyComunas.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
    }
});

export default legacyComunasSlice.reducer;